import script from "./AccountsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountsPage.vue?vue&type=script&setup=true&lang=js"

import "./AccountsPage.vue?vue&type=style&index=0&id=501791cc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-501791cc"]])

export default __exports__